import {useHistory} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {UserContext} from "../../contexts/UserContext";
import {filterBy, orderBy} from "@progress/kendo-data-query";
import {semcastAxios, showErrorToastMessage, showSuccessToastMessage, signInAs} from "../../Utils/Common";
import {
    GROUPS_ACCESSIBLE_PIXELS,
    IDX_PIXELS_API,
    IDX_PIXELS_DATA_API, SUPER_ADMIN_IDX_PIXELS_LIST, USER
} from "../../api/constants";
import {Button, DropDownButton, DropDownButtonItem} from "@progress/kendo-react-buttons";
import LoadOverlay from "../Components/SharedComponents/LoadOverlay";
import {ExcelExport} from "@progress/kendo-react-excel-export";
import {Grid, GridToolbar} from "@progress/kendo-react-grid";
import {GridColumn as Column} from "@progress/kendo-react-grid/dist/npm/GridColumn";
import {Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import gearIcon from "../images/gearIcon.PNG";
import NewIdxTagDialog from "./NewIdxTagDialog";
import IdxTagInstuctions from "./IdxTagInstructions";
import {getFTPSettings} from "../../actions/OnBoardingActions";
import EditIdxTagDialog from "./EditIdxTagDialog";
import {InputClearValue, InputSeparator, TextBox} from "@progress/kendo-react-inputs";
import {SvgIcon} from "@progress/kendo-react-common";
import {xIcon} from "@progress/kendo-svg-icons";
import {semcastingAdobeSvg} from "../Components/Segmentation/temporaryresources/images";
import {DropdownFilterCell} from "../Components/Permission/dropdownFilterCell";
const initialFilter = {
    logic: "and",
    filters: [
        {
            field: "domain",
            operator: "contains",
            value: ""
        }
    ]
};

const initialSort = [
    {
        field: "created_at",
        dir: "desc"
    }
];

function formatUnixTime(unixTime) {
    if(unixTime == null) return null;

    const date = new Date(unixTime);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear().toString().slice(-2);
    return date;
}

function getCurrentDateTime() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');

    const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return currentDateTime;
}
const AdminIdxTagManager = () => {
    const history = useHistory();
    const [overlayActive, setOverlayActive] = useState(false);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(initialFilter);
    const [sort, setSort] = useState(initialSort);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(25);

    const processedData = useMemo(() => orderBy(filterBy(data, filter), sort), [data, filter, sort]);
    useEffect(() => {
        const total = processedData.length;
        if (total === 0) {
            setSkip(0);
            return;
        }
        if (skip >= total) {
            const newSkip = Math.max(total - take, 0);
            if (newSkip !== skip) {
                setSkip(newSkip);
            }
        }
    }, [processedData, skip, take]);
    const [showTagCode, setShowTagCode] = useState(false);
    const [pixelTagId, setPixelTagId] = useState("");
    const [pixelTagObj, setPixelTagObj] = useState({});


    const {user, setUser} = React.useContext(UserContext);

    const exportExcell = React.useRef(null);
    const exportExport = () => {
        if (exportExcell.current !== null) {
            exportExcell.current.save(orderBy(filterBy(data, filter), sort));
        }
    };



    const getIDXPixelsData = async () => {
        try {
            let response = await semcastAxios.get(SUPER_ADMIN_IDX_PIXELS_LIST, {withCredentials: true})
                .then((res) => {
                    let dataTemp = res.data.data;
                    dataTemp.forEach((idxTag) => {
                        idxTag.created_at = formatUnixTime(idxTag.created_at);
                        idxTag.updated_at = formatUnixTime(idxTag.updated_at);
                        idxTag.deleted_at = formatUnixTime(idxTag.deleted_at);
                        idxTag.user_name = idxTag.first_name + " " + idxTag.last_name;
                    })
                    setData(dataTemp);
                    console.log("dataTemp ", dataTemp)
                }).catch((error) => {
                    if (error.response) {
                        showErrorToastMessage("Response Error: " + error.response.data.data, 10);
                        console.log(error.response);
                    }
                    if (error.request) {
                        showErrorToastMessage("Request Error: " + error.request.data.data, 10);
                        console.log(error.request);
                    }
                });
        } catch (error) {
            console.log(error)
            showErrorToastMessage("Error accessing Tracking Pixel information. " + error);
        }


    }





    const refreshTable = async () => {
        // await Promise.allSettled([getAvailableGroups(), getTrackingPixels(), getIDXPixelsData(), getTransferLog()]);
        await Promise.allSettled([ getIDXPixelsData()]);
    }

    useEffect(async () => {

        setOverlayActive(true);
        // let groupNameFilterCell = document.querySelector('[title="domain-filter"]');
        // groupNameFilterCell.placeholder = "Search..."

        await Promise.allSettled([refreshTable()]).then(() => {
            setOverlayActive(false);
        })

    }, []);


    const handleDropdownSelect = (e, dataItem) => {
        switch (e.item.text) {
            case "Analytics Pixel Code":
                // setPixelDomain(dataItem.domain);
                setPixelTagId(dataItem.id);
                setPixelTagObj(dataItem);
                setShowTagCode(true);
                break;
            default:
                break;
        }
    }
    const updatedAtCell = (props) => {
        // console.log("updatedCell ", props);
        const updated = props.dataItem.updated_at ? props.dataItem.updated_at : "-" ;
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {updated}
            </td>
        )
    };
    const dateCell = (props) => {
        console.log("updatedCell ", props);
        const val = props.dataItem[props.field];
        let date;
        let month;
        let day;
        let year;
        if(val){
             month = val.getMonth() + 1;
             day = val.getDate();
             year = val.getFullYear().toString().slice(-2);
            date = `${month}/${day}/${year}`
        }else{
            date = `-`
        }

        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {date}
            </td>
        )
    };
    const labelCell = (props) => {
        // console.log("updatedCell ", props);
        const label = props.dataItem.label ? props.dataItem.label : "-" ;
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {label}
            </td>
        )
    };

    const nameCell = (props) => {
        // console.log("updatedCell ", props);
        const nameLabel = props.dataItem.user_name ? props.dataItem.user_name : "-" ;
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {nameLabel}
            </td>
        )
    };
    const companyCell = (props) => {
        // console.log("updatedCell ", props);
        const companyLabel = props.dataItem.company ? props.dataItem.company : "-" ;
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {companyLabel}
            </td>
        )
    };
    const typeCell = (props) => {
        let tagType = "";
        const segmentNamingType = props.dataItem.segment_naming_type ? props.dataItem.segment_naming_type : "-" ;
        switch (segmentNamingType) {
            case "CATEGORY":
                tagType = "Category";
                break;
            case "URL":
                tagType = "Website";
                break;
            case "NONE":
                tagType = "No Segments";
                break;
            default:
                tagType = "-";
        }

        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {tagType}
            </td>
        )
    };

    const groupNameCell = (props) => {
        // console.log("groupNameCell ", props);
        // const groupName = getGroupNameById(groupsArr,props.dataItem.group_id);
        const groupName = props.dataItem.group_name
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {groupName}
            </td>
        )
    };
    const ftpCell = (props) => {
        // console.log("ftpCell ", props);
        // const ftpName = getFTPById(availableFTPConnections,props.dataItem.ftp_settings_id);
        const ftpName = props.dataItem.ftp_settings_name
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {ftpName}
            </td>
        )
    };

    const headerCell = props => {
        return <div style={{
            textAlign: '-webkit-center'
        }}>
            <span style={{
                textAlign: '-webkit-center'
            }}>{props.title}</span>
        </div>;
    };

    const categoryFilterCell = props => {
        const types = Array.from(new Set(data.map(p => p[props.field] ? p[props.field] : ''))).sort((a, b) => a.localeCompare(b));
        return (
            <DropdownFilterCell {...props} data={types} defaultItem={'Select Filter...'} style={{ width: 'auto' }} />
        )
    }
    const MyEditCommandCell = (props) => {
        return (
            <td className={"idx-tag-gear-dropdown-div"} key={props.dataItem.id}>
                <DropDownButton
                    className={"btn btn-primary shadow btn-xs sharp idx-gear-button"}
                    id={"idxDropdownMenuButton" + props.dataItem.id}
                    textField={"text"}
                    icon="cog"
                    title={"IDX Tag Options"}
                    onItemClick={(e) => handleDropdownSelect(e, props.dataItem)}
                >
                    <DropDownButtonItem text="Analytics Pixel Code"/>
                </DropDownButton>

            </td>
        )
    };
    const SignInAsCell = (props) => {
        // let user = JSON.parse(sessionStorage.getItem(USER));
        const handleSignInAs = async () => {
            // console.log("handleSignInAsProps=", props)
            if (user?.isAdmin) {
                try {
                    await signInAs(props.dataItem.user_id);
                } catch (error) {
                    console.error('Error while signing in as:', error);
                }
            }
        };

        return (
            <td>
                {user?.isAdmin && props.dataItem.deleted_at === null &&
                    <Button
                        className="button-standard button-submit button-no-left-margin"
                        onClick={handleSignInAs}
                    >
                        Sign In As
                    </Button>
                }
            </td>
        );
    };

    return (
        <div>
            <LoadOverlay active={overlayActive} height={50} width={50}>

                <div className={"idx-tag-manager-outer-container"}>
                    <div className={"idx-grid"}>
                        <ExcelExport ref={exportExcell} fileName={`IDX Tags - ${user.first_name} ${user.last_name} ${getCurrentDateTime()}`}>
                            <Grid
                                data={processedData.slice(skip, skip + take)}
                                skip={skip}
                                take={take}
                                total={processedData.length}
                                filterable={true}
                                filter={filter}
                                dataItemKey={"id"}
                                autoProcessData={true}
                                onFilterChange={(e) => setFilter(e.filter)}
                                sortable={true}
                                sort={sort}
                                onSortChange={(e) => {
                                    setSort(e.sort);
                                }}
                                resizable={true}
                                style={{ height: '65vh' }}
                                pageable={{ buttonCount: 5, pageSizes: [10, 25, 50, 100] }}
                                onPageChange={(e) => {
                                    setSkip(e.page.skip);
                                    setTake(e.page.take);
                                }}
                            >
                                <GridToolbar>
                                    <div className={"idx-grid-toolbar-container"}>
                                        <div className={"idx-grid-toolbar-left"}>

                                        </div>
                                        <div className={"idx-grid-toolbar-right"}>
                                            <Button
                                                className={"button-standard button-white"}
                                                iconClass={"k-icon k-i-download"}
                                                onClick={exportExport}
                                            >
                                                as CSV
                                            </Button>
                                        </div>
                                    </div>
                                </GridToolbar>
                                <Column field={"id"} title={"Tag ID"} width={80}/>
                                <Column field={"segment_naming_type"} title={"Tag Type"} cell={typeCell} filterCell={categoryFilterCell}/>
                                <Column field={"label"} title={"Description"} cell={labelCell} />
                                <Column field={"created_at"} title={"Created"} cell={dateCell} filterable={false} width={100}/>
                                <Column field={"updated_at"} title={"Updated"} cell={dateCell} filterable={false} width={100}/>
                                <Column field={"group_name"} title={"Group"} cell={groupNameCell} filterCell={categoryFilterCell}/>
                                <Column field={"ftp_settings_name"} title={"FTP"} cell={ftpCell}/>
                                <Column field={"user_name"} title={"User"} cell={nameCell} filterCell={categoryFilterCell}/>
                                <Column field={"company"} title={"Company"} cell={companyCell} filterCell={categoryFilterCell}/>
                                <Column cell={MyEditCommandCell} filterable={false} width={50}/>
                                <Column cell={SignInAsCell} filterable={false} width={125}/>
                            </Grid>
                        </ExcelExport>
                    </div>
                </div>


                {showTagCode && <IdxTagInstuctions pixelTagId={pixelTagId} setShowTagCode={setShowTagCode} pixelTagObj={pixelTagObj}/>}


            </LoadOverlay>
        </div>
    )
}
export default AdminIdxTagManager;
